module.exports = "https://static.wagwalking.com/_next/static/images/daily-wag-desktop-placeholder-073f3d7548ec7f0d6f6f90c9e650a4ab.jpeg";